import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShoppingCartinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm7 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2-11a1 1 0 0 1 .894 1.447l-2.5 6A1 1 0 0 1 12.5 12h-6a1 1 0 0 1-.942-.664l-1.83-6.124C3.502 4.578 3.038 3 2 3H0V1h1.999c2.328 0 2.89 1.839 3.56 3H15z",
		fill: "currentColor",
		fillRule: "evenodd"
	})
});
export default SvgShoppingCartinline;
